import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Order } from '../model/order.model';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.prod';
import { Paginated } from '../model/paginated.model';

@Injectable()
export class OrderService extends BaseAPIClass {
  baseUrl = environment.serverBaseUrl;
  baseUrl2 = environment.serverBaseUrl;
  baseUrl5 = environment.serverBaseUrl;

  public isLoading = false;
  private categoriasSearchUrl = this.baseUrl + '/pedido/search?term=';

  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/pedido';
    this.baseUrl5 = this.baseUrl + '/search?term=';

    this.baseUrl2 =this.baseUrl2+ '/';
    
    console.log(this.baseUrl2);
  }

  editarOrden(id: string): Observable<Order> {
    return this.httpClient.get<Order>(this.baseUrl + '/entrega/' + id);
  }

  editarPedido(object: any) {
    return this.httpClient.post(this.baseUrl + '/editar', object);
  }

  guardarEntrega(object: any) {
    return this.httpClient.post(this.baseUrl + '/entrega', object);
  }
  realizarVenta(object: any) {
    return this.httpClient.post(this.baseUrl + '/venta', object);
  }

  imprimirPedidoG(object: any) {
    return this.httpClient.post(this.baseUrl + '/calculo', object,{responseType: "blob"});
  }
  imprimirPedidoGM(object: any) {
    return this.httpClient.post(this.baseUrl + '/monetizado-pdf', object,{responseType: "blob"});
  }


  despacharPedido(id: string) {
    return this.httpClient.get(this.baseUrl + '/despachar/' + id);
  }

  imprimirPedido(id: any): Observable<Blob> {
    return this.httpClient.get( this.baseUrl2 +'reporte-pdf/' + `${id}`, {
      responseType: 'blob'
    });
  }
  anularPedido(id: string) {
    return this.httpClient.get(this.baseUrl + '/anular/' + id);
  }

  getPedidos(id: string, estado: string): Promise<Paginated> {
    this.isLoading = true;
    return this.httpClient
      .get(this.baseUrl + '/user/' + id + '/estado/' + estado)
      .toPromise()
      .then(response => {
        console.log(response);
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  getPedidosAtUrl(url: string): Promise<Paginated> {
    this.isLoading = true;
    // var url2 = this.categoriasSearchUrl +  '&user_id='+ user_id;
    console.log(url);
    return this.httpClient
      .get(url)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }




  getPedidosAtUrl2(pagenumber: number, user_id:string, estado:string): Promise<Paginated> {
    this.isLoading = true;
    // var url2 = this.categoriasSearchUrl +  '&user_id='+ user_id;
   // console.log(url);
    return this.httpClient
    .get(this.baseUrl5+ "&page="+pagenumber + "&user_id="+user_id + "&estado="+estado)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }


  search(term: string, user_id: string, estado: string): Promise<Paginated> {
    this.isLoading = true;
    const url2 =
      this.categoriasSearchUrl +
      term +
      '&user_id=' +
      user_id +
      '&estado=' +
      estado;
    
    return this.httpClient
      .get(url2)
      .toPromise()
      .then(response => {
        this.isLoading = false;
        return response as Paginated;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    // this.isLoading = false;
    return Promise.reject(error.message || error);
  }
}
